// extracted by mini-css-extract-plugin
module.exports = {"carousel_cont":"styles_carousel_cont__OGYor","title":"styles_title__lCyX4","carousel":"styles_carousel__gAaqt"};